/**
 * Constants for cookie settings labels.
 *
 * @module cookieSettings.constants
 */

/**
 * The standardized label for the performance/analytics cookie.
 */
export const PERFORMANCE_ANALYTICS_COOKIE_LABEL: string = 'Performance/analytics cookies'
